import { render } from "./PublishForm.vue?vue&type=template&id=3607bb8f"
import script from "./PublishForm.vue?vue&type=script&lang=js"
export * from "./PublishForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__